function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.704 3.00337C11.3223 2.29544 10.3036 2.30478 9.93495 3.01959L2.17722 18.0637C1.83402 18.7292 2.31718 19.522 3.06601 19.522H18.9341C19.691 19.522 20.1735 18.7137 19.8143 18.0474L11.704 3.00337ZM8.15737 2.10295C9.26319 -0.0414824 12.3195 -0.0695064 13.4644 2.05429L21.5748 17.0984C22.6523 19.0971 21.2048 21.522 18.9341 21.522H3.06601C0.819513 21.522 -0.629964 19.1437 0.399649 17.147L8.15737 2.10295Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7847 7.19092C11.337 7.19092 11.7847 7.63863 11.7847 8.19092V12.1909C11.7847 12.7432 11.337 13.1909 10.7847 13.1909C10.2324 13.1909 9.78467 12.7432 9.78467 12.1909V8.19092C9.78467 7.63863 10.2324 7.19092 10.7847 7.19092Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.78467 16.1909C9.78467 15.6386 10.2324 15.1909 10.7847 15.1909H10.7947C11.347 15.1909 11.7947 15.6386 11.7947 16.1909C11.7947 16.7432 11.347 17.1909 10.7947 17.1909H10.7847C10.2324 17.1909 9.78467 16.7432 9.78467 16.1909Z"
});

function SvgSxExclamationTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxExclamationTriangle);
export default __webpack_public_path__ + "static/media/sx-exclamation-triangle.92c4a693.svg";
export { ForwardRef as ReactComponent };